export enum EOriginStatus
{
    RECEIVED = 'Received', 
    CONFIRMED = 'Confirmed', 
    SITED = 'Sited', 
    CANCELED = 'Canceled'
}